import { Children, createElement, isValidElement } from 'react';

export function ComposeChildren({ children }: { children: React.ReactNode }) {
	const childs = Children.toArray(children);
	const lastChild = childs.pop();
	return childs.reduceRight(
		(child, element) =>
			isValidElement(element)
				? createElement(element.type, element.props, child)
				: child,
		lastChild,
	);
}
